import AdminListPage from "./components/AdminListPage";
export default function LejarList() { return <AdminListPage title="Senarai Lejar" endpoint="/admin/lejar" />; }
